// Wording for the command palette (Ctrl/⌘+K). The entity group headers are not repeated here —
// they reuse the `nav.*` labels, so a section is named the same in the drawer and in the palette.
export default {
  label: "Search",
  placeholder: "Search or jump to…",
  groups: {
    recent: "Recently visited",
    create: "Create",
    navigate: "Go to",
  },
  empty: {
    no_results: "Nothing found.",
    keep_typing: "Keep typing to search…",
  },
  hints: {
    move: "Navigate",
    open: "Open",
    close: "Close",
    back: "Back",
  },
  // A tab like "Construction reports" needs an entity to be opened on. These name that second step —
  // singular, because exactly one is chosen (the `nav.*` labels are plural and read wrong here).
  pick: {
    PROJECT: "Pick a project",
    CUSTOMER: "Pick a customer",
    USER: "Pick an employee",
    MATERIAL: "Pick a material",
    MACHINE: "Pick a machine",
    SUPPLIER: "Pick a supplier",
    ADDITIONAL_EFFORT: "Pick an additional effort",
    PACKET: "Pick a packet",
  },
}
